import { Component, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'

import { APIService } from 'api/module'
import { NotifyService } from 'common/util/module'
import { permissionGuard } from 'main/services/identity.service'

const LOCATOR_ROUTE: Route = {
  path: '',
  pathMatch: 'full',
  resolve: {
    _: async (route: ActivatedRouteSnapshot) => {
      const routeRootID = parseInt(route.paramMap.get('rootId')!)
      const routePath = route.queryParams.path

      const api = inject(APIService)
      const notify = inject(NotifyService)
      const translate = inject(TranslateService)
      const router = inject(Router)

      const root = await api.mediaLibrary.getMediaRoot({ id: routeRootID })
      let path = root.path
      if (path === '.') {
        path = ''
      }
      if (routePath) {
        if (path) {
          path += '/'
        }
        path += routePath
      }
      const files = await api.mediaLibrary.getAllMediaFiles({ volume: root.volume.id, path })
      if (files.length === 0) {
        notify.warning(translate.instant('File not found'))
        return
      }

      if (files[0].isDir) {
        const browsePath = route.toString().includes('/flat/') ? '/media/browse/flat' : '/media/browse'
        router.navigateByUrl(`${browsePath}/${root.id}/${files[0].id}`, { replaceUrl: true })
      } else if (files[0].bundle) {
        const bundle = await api.mediaLibrary.getMediaFileBundle({ id: files[0].bundle })
        if (bundle.asset) {
          router.navigateByUrl(`/media/view/${root.id}/${files[0].parent}/${bundle.asset.id}`, { replaceUrl: true })
        }
      }
    },
  },
  canActivate: [permissionGuard('media:access')],
  runGuardsAndResolvers: 'always',
}

@Component({
  template: '',
})
export class MediaBrowseLocatorView {
  static ROUTES: Route[] = [
    {
      ...LOCATOR_ROUTE,
      path: 'media/browse/path/:rootId',
      component: MediaBrowseLocatorView,
    },
    {
      ...LOCATOR_ROUTE,
      path: 'media/browse/path/:rootId/',
      component: MediaBrowseLocatorView,
    },
    {
      ...LOCATOR_ROUTE,
      path: 'media/browse/flat/:rootId',
      component: MediaBrowseLocatorView,
    },
    {
      ...LOCATOR_ROUTE,
      path: 'media/browse/file/:id',
      component: MediaBrowseLocatorView,
      resolve: {
        _: async (route: ActivatedRouteSnapshot) => {
          const routeFileID = parseInt(route.paramMap.get('id')!)

          const api = inject(APIService)
          const notify = inject(NotifyService)
          const translate = inject(TranslateService)
          const router = inject(Router)

          const file = await api.mediaLibrary.getMediaFile({ id: routeFileID, includeRoot: true })
          if (!file.root) {
            notify.warning(translate.instant('This file does not belong to any Media Root!'))
            return
          }
          console.info(`File found in root ${file.root.name}`)
          router.navigateByUrl(`/media/browse/${file.root.id}/${file.id}`, { replaceUrl: true })
        },
      },
    },
  ]
}
